import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import RejectionStatusCd from 'domain/enums/RejectionStatusCd';
import RejectionTypeCd from 'domain/enums/RejectionTypeCd';
import RejectionReason from 'domain/types/RejectionReason';
import { RejectionAction } from './RejectionAction';
import { GroupReferenceKey } from 'features/cart/CartSlice';

interface IPrecheckFailed {
  rejections: RejectionReason[];
  groupRefKey: GroupReferenceKey;
}

const PrecheckFailed = (props: IPrecheckFailed) => {
  const hasUnresolved = props.rejections.some(
    (r) => r.statusCd === RejectionStatusCd.NOT_RESOLVED
  );
  const hasPending = props.rejections.some(
    (r) => r.statusCd === RejectionStatusCd.PENDING
  );

  type RejectionMap = {
    [key: string]: {
      reasons: RejectionReason[];
      typeDescr: RejectionTypeCd;
    };
  };

  function mapRejections(statusCd: RejectionStatusCd) {
    const map: RejectionMap = {};
    const reasons = props.rejections.filter((r) => r.statusCd === statusCd);
    for (const reason of reasons) {
      const groupKey = reason.typeCd;
      const group = map[groupKey] || {
        reasons: [],
        typeDescr: reason.typeDescr,
      };
      group.reasons.push(reason);
      map[groupKey] = group;
    }
    return map;
  }

  function listReasons(map: RejectionMap) {
    return (
      <ul>
        {Object.entries(map).map(([typeCd, { typeDescr, reasons }]) => (
          <li key={typeCd}>
            <RejectionAction
              statusCd={reasons[0].statusCd}
              typeCd={typeCd as RejectionTypeCd}
              typeDescr={typeDescr}
              reasons={reasons}
              groupRefKey={props.groupRefKey}
            />
          </li>
        ))}
      </ul>
    );
  }

  /**
   * All unresolved rejection codes, grouped by type
   */
  const unresolved = mapRejections(RejectionStatusCd.NOT_RESOLVED);
  const pending = mapRejections(RejectionStatusCd.PENDING);

  if (hasUnresolved) {
    return (
      <>
        <Alert type={AlertType.danger}>
          <div>
            <h3>Incomplete Application</h3>
            <p>
              {hasPending
                ? 'Outstanding:'
                : 'Please fix below in order to resubmit:'}
            </p>
            {listReasons(unresolved)}
          </div>
        </Alert>
        {hasPending && (
          <Alert type={AlertType.warning}>
            <p>Addressed:</p>
            {listReasons(pending)}
          </Alert>
        )}
      </>
    );
  }
  return (
    <Alert type={AlertType.warning}>
      <div>
        <h3>Application is ready to be re-submitted.</h3>
        <p>Navigate to the bottom of this page to re-submit the application</p>
        {listReasons(pending)}
      </div>
    </Alert>
  );
};

export default PrecheckFailed;
